

























































import Vue from 'vue';
import LightOutlineButton from '@/components/shared/LightOutlineButton.vue';
import ClipboardCheckBlueGreyHollow from '@/assets/ClipboardCheckBlueGreyHollow.vue';
import ClipboardBlue from '@/assets/ClipboardBlue.vue';

export default Vue.extend({
  components: {
    LightOutlineButton,
    'clipboard-check': ClipboardCheckBlueGreyHollow,
    ClipboardBlue,
  },
  props: {
    showComplete: {
      type: Boolean,
      required: true,
    },
    showActionsMenu: {
      type: Boolean,
      required: true,
    },
  },
});
